module.exports = __webpack_public_path__ + "img/terroir-disc-4.e14c46fe.jpg";